// extracted by mini-css-extract-plugin
export default {"star":"Star_star__KqVO+","absolute":"Star_absolute__hNwZF"};